/* 商品页运费预估(DEV_PLAN A1)。
 * - 监听 variantChange(pubsub)重新请求,debounce + 内存缓存
 * - 国家选择持久化 localStorage,与购物车组件共享
 * - 超时/异常回退 shipping policy 文案,不阻挡购买 */
if (!customElements.get('shipping-estimate')) {
  const COUNTRY_KEY = 'shipping-estimate:country';
  const TIMEOUT_MS = 5000;
  const DEBOUNCE_MS = 250;

  customElements.define(
    'shipping-estimate',
    class ShippingEstimate extends HTMLElement {
      connectedCallback() {
        this.endpoint = this.dataset.endpoint;
        this.variantId = this.dataset.variantId;
        this.weights = JSON.parse(this.querySelector('[data-variant-weights]').textContent);
        this.cache = new Map();
        this.countrySelect = this.querySelector('.shipping-estimate__country');

        const saved = localStorage.getItem(COUNTRY_KEY);
        if (saved && this.countrySelect.querySelector(`option[value="${saved}"]`)) {
          this.countrySelect.value = saved;
        }

        this.countrySelect.addEventListener('change', () => {
          localStorage.setItem(COUNTRY_KEY, this.countrySelect.value);
          this.scheduleFetch();
        });

        /* 数量变化联动(Dawn 的数量输入框 id="Quantity-{section}") */
        this.qtyInput = document.getElementById('Quantity-' + this.dataset.sectionId);
        if (this.qtyInput) {
          ['change', 'input'].forEach((ev) =>
            this.qtyInput.addEventListener(ev, () => this.scheduleFetch())
          );
        }

        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event.data?.variant;
            if (!variant || String(event.data.sectionId) !== this.dataset.sectionId) return;
            this.variantId = String(variant.id);
            this.scheduleFetch();
          });
        }

        this.scheduleFetch();
      }

      disconnectedCallback() {
        this.variantUnsubscriber?.();
      }

      scheduleFetch() {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => this.fetchQuote(), DEBOUNCE_MS);
      }

      show(state) {
        ['loading', 'quote', 'fallback'].forEach((name) => {
          this.querySelector(`.shipping-estimate__${name}`).classList.toggle('hidden', name !== state);
        });
        this.querySelector('.shipping-estimate__note').classList.toggle('hidden', state !== 'quote');
      }

      async fetchQuote() {
        const country = this.countrySelect.value;
        const grams = this.weights[this.variantId] ?? 0;
        if (!country || grams <= 0) return this.show('fallback');
        const quantity = Math.max(1, Number(this.qtyInput && this.qtyInput.value) || 1);

        const cacheKey = `${country}:${this.variantId}:${quantity}`;
        if (this.cache.has(cacheKey)) return this.render(this.cache.get(cacheKey));

        this.show('loading');
        const requestId = (this.requestId = (this.requestId || 0) + 1);
        try {
          const response = await fetch(this.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              country,
              currency: this.currency,
              env: this.env,
              items: [{ variantId: Number(this.variantId), quantity, grams }],
            }),
            signal: AbortSignal.timeout(TIMEOUT_MS),
          });
          if (!response.ok) throw new Error(`quote ${response.status}`);
          const data = await response.json();
          if (requestId !== this.requestId) return;
          this.cache.set(cacheKey, data);
          this.render(data);
        } catch (error) {
          if (requestId === this.requestId) this.show('fallback');
        }
      }

      render(data) {
        if (!data.available || !data.quotes?.length) return this.show('fallback');
        const quote = data.quotes[0];
        /* API 返回店铺主货币(GBP);用 Shopify 自身汇率换算成页面展示货币,与 Checkout 同源 */
        const sc = window.Shopify && window.Shopify.currency;
        const rate = sc && sc.rate ? Number(sc.rate) : 1;
        const cur = (sc && sc.active) || data.currency;
        const fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency', currency: cur, maximumFractionDigits: 2,
        });
        const amount =
          quote.amountMin === quote.amountMax
            ? fmt.format(quote.amountMin * rate)
            : `${fmt.format(quote.amountMin * rate)}–${fmt.format(quote.amountMax * rate)}`;
        const eta = quote.etaDaysMin != null && quote.etaDaysMax != null
          ? ` · ${quote.etaDaysMin}–${quote.etaDaysMax} business days`
          : '';
        this.querySelector('.shipping-estimate__quote').textContent = `Estimated ${amount}${eta}`;
        this.show('quote');
      }
    }
  );
}
